module.exports = __webpack_public_path__ + "static/007-4e84bd726587c362440dee84f0fa5699.png";